import React from 'react';
import ReactModal from 'react-modal';

import CombineProfileLayout from './CombineProfileLayout';

const CombineProfileModal = ({ isOpen, data, handleSubmit, handleCloseModal }) => {
  return (
    <ReactModal
      isOpen={isOpen}
      contentLabel="Modal"
      className="modal-container overflow-auto"
      overlayClassName="modal-overlay">
      <CombineProfileLayout
        handleCloseModal={handleCloseModal}
        handleSubmit={handleSubmit}
        data={data}
      />
    </ReactModal>
  );
};

export default CombineProfileModal;
